import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { store } from './store';
import AppErrorBoundary from './components/common/AppErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { installBrowserTranslateGuard } from './utils/browserTranslateGuard';

installBrowserTranslateGuard();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
